import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { InvoiceItemFormControls } from '@wilson/invoicing/interfaces';
import { flatMap, groupBy, omit } from 'lodash';

const ERROR_DUPLICATE = 'isDuplicatedName';

export function duplicateRuleNameValidator(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const array = formArray as FormArray<FormGroup<InvoiceItemFormControls>>;
    const controls = array.controls;

    // Group controls by composite (agreementName, ruleName) and find duplicates
    const ruleKeysWithIndices = controls.map((control, index) => {
      const agreementName = control.get('agreementName')?.value || '';
      const ruleName = control.get('ruleName')?.value || '';
      const ruleKey = `${agreementName}::${ruleName}`;

      return {
        ruleKey,
        index,
      };
    });

    const grouped = groupBy(ruleKeysWithIndices, 'ruleKey');
    const duplicateIndices = flatMap(
      Object.values(grouped).filter((group) => group.length > 1),
      (group) => group.map((item) => item.index),
    );

    // Clear existing errors
    controls.forEach((control) => {
      const ruleNameControl = control.get('ruleName') as FormControl | null;
      if (
        ruleNameControl?.errors &&
        ruleNameControl.hasError(ERROR_DUPLICATE)
      ) {
        const remainingErrors = omit(ruleNameControl.errors, [ERROR_DUPLICATE]);
        ruleNameControl.setErrors(
          Object.keys(remainingErrors).length > 0 ? remainingErrors : null,
          { emitEvent: false },
        );
      }
    });

    // Set errors
    let hasErrors = false;
    duplicateIndices.forEach((index) => {
      const ruleNameControl = controls[index].get(
        'ruleName',
      ) as FormControl | null;
      if (ruleNameControl) {
        ruleNameControl.setErrors(
          { ...ruleNameControl.errors, [ERROR_DUPLICATE]: true },
          { emitEvent: false },
        );
        hasErrors = true;
      }
    });

    return hasErrors ? { duplicateRuleNames: true } : null;
  };
}
